import { Launches } from "@oldDashboard/legacyModels/launches.model";
import { LaunchesSerializer } from "@oldDashboard/legacyModels/serializers/launchesSerializer";
import { TimePeriodsSerializer } from "@oldDashboard/legacyModels/serializers/timePeriodsSerializer";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandFiltersGuideposts {

    async run(affiliateSelected: String, launchSelected: String) {
        let path = `launches/`;
        if(affiliateSelected != "")
            path = `launches/?affiliate_id=${affiliateSelected}&launch_id=${launchSelected}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success) {
                const launches = this.deserializeLaunches(response.data.launches);
                const periods = this.deserializePeriods(response.data.time_periods);
                const launchId : string = response.data.launch_id;
                const timePeriodKey : string = response.data.time_period_key;
                return { launches, periods, launchId, timePeriodKey };
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserializeLaunches(data: any) : Launches[] {
        const serializer = new LaunchesSerializer();
        return serializer.deserializeList(data);
    }

    deserializePeriods(data: any) : TimePeriods[] {
        const serializer = new TimePeriodsSerializer();
        return serializer.deserializeList(data);
    }
}

